export default function Logo(props) {
  return <img src="/logo_cabecalho.png" alt="logo-quitapay" {...props} />;
}
